import { NgModule } from '@angular/core';
import { AclPipe } from './acl.pipe';
import { AgePipe } from './age.pipe';
import { AreaImperialPipe } from './area-imperial.pipe';
import { AreaMetricPipe } from './area-metric.pipe';
import { AreaPipe } from './area.pipe';
import { ChunkPipe } from './chunk.pipe';
import { DefaultPipe } from './default.pipe';
import { FilterPipe } from './filter.pipe';
import { JoinPipe } from './join.pipe';
import { NotificationTypePipe } from './notification-type.pipe';
import { OrderByPipe } from './order-by.pipe';
import { PairRoomsPipe } from './pair-rooms.pipe';
import { SearchFilterPipe } from './search-filter.pipe';
import { SplitPipe } from './split.pipe';
import { ValuePipe } from './value.pipe';
import { YesNoPipe } from './yes-no.pipe';


@NgModule({
    imports: [
        AclPipe,
        AgePipe,
        AreaImperialPipe,
        AreaMetricPipe,
        AreaPipe,
        ChunkPipe,
        DefaultPipe,
        FilterPipe,
        JoinPipe,
        NotificationTypePipe,
        OrderByPipe,
        PairRoomsPipe,
        SearchFilterPipe,
        SplitPipe,
        ValuePipe,
        YesNoPipe,
    ],
    // TODO: remove
    providers: [
        AclPipe,
        AgePipe,
        AreaImperialPipe,
        AreaMetricPipe,
        AreaPipe,
        ChunkPipe,
        DefaultPipe,
        FilterPipe,
        JoinPipe,
        NotificationTypePipe,
        OrderByPipe,
        PairRoomsPipe,
        SearchFilterPipe,
        SplitPipe,
        ValuePipe,
        YesNoPipe,
    ],
    exports: [
        AclPipe,
        AgePipe,
        AreaImperialPipe,
        AreaMetricPipe,
        AreaPipe,
        ChunkPipe,
        DefaultPipe,
        FilterPipe,
        JoinPipe,
        NotificationTypePipe,
        OrderByPipe,
        PairRoomsPipe,
        SearchFilterPipe,
        SplitPipe,
        ValuePipe,
        YesNoPipe,
    ],
})
export class PipesModule {}
